import styled from 'styled-components';

export const FilterPaneRoot = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 24px 0;
`;
